import { SEARCH_FORM_ID_MANAGER } from "components/constent";
import TableRow from "components/rows/tableRow";
import Select from "components/select";
import PhoneSelect from "components/select/phone/phone";
import { useTranslation } from "react-i18next";
import { onSubmit } from "./handles";

type ISearchFromProps = {
  onSetParam: (param: any) => void;
};

export default function SearchForm({ onSetParam }: ISearchFromProps) {
  const { t } = useTranslation();
  return (
    <>
      <form
        id={SEARCH_FORM_ID_MANAGER}
        onSubmit={(e) => {
          const param = onSubmit(e);
          onSetParam(param);
        }}
      >
        <table>
          <tbody>
            <TableRow title={t("manager_man_row")}>
              <ul>
                <li>
                  <label htmlFor="">{t("manager_no")}</label>
                  <input type="text" name="manNo" />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_eml_id_cmm")}</label>
                  <input type="text" name="emlId" />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_phone_cmm")}</label>
                  <input type="text" name="mobNo" />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_country_no_cmm")}</label>
                  <PhoneSelect
                    styles="flex-1 h-full bg-white border-gray-400"
                    ulStyles="top-[26px]"
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_stt_cmm")}</label>
                  <Select
                    name={"uyn"}
                    options={manYns}
                    styles="flex-1 bg-white border-1"
                    ulStyles="top-[28px]"
                  />
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      </form>
    </>
  );
}

const manYns = [
  {
    ko: "탈퇴",
    en: "withdrawn",
    value: "Y",
    code: "soYn",
  },
  {
    ko: "신청",
    en: "requested",
    value: "Y",
    code: "joiAprYn",
  },
  {
    ko: "휴먼",
    en: "dormant",
    value: "Y",
    code: "lckYn",
  },
];
